import { render } from "./SiteHeaderRibbon.vue?vue&type=template&id=5cba1000&ts=true"
import script from "./SiteHeaderRibbon.vue?vue&type=script&lang=ts"
export * from "./SiteHeaderRibbon.vue?vue&type=script&lang=ts"

import "./SiteHeaderRibbon.vue?vue&type=style&index=0&id=5cba1000&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__